export const convertEnumToArray = (en, cb) => Object.keys(en)
    .map((enumKey, index) => cb({
    enumKey,
    enumValue: en[enumKey],
    index,
}));
